export default __webpack_public_path__ + "b201c496b56e4a70113826aa6478f1a0.png";